import React from 'react';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import CompanyRegistrationInput from './CompanyRegistrationInput';

interface Props {
  question: FlowsQuestion;
}

const CompanyRegistrationInputPicker: React.FC<
  React.PropsWithChildren<Props>
> = ({ ...props }) => {
  return <CompanyRegistrationInput {...props} />;
};

export default CompanyRegistrationInputPicker;
